$(function(){
  linkOpenNewTab();
  gNav();
  dropdownMenu();
  pageTop();
  pageLink();
  // cookieConsent();
  variantSelectModal();
  productDetailTabs();
  processingMultipleGetServerDate();
  processingImageArrowButton();
  pfsReload();
  openProductFilters();
  itemGalleryModal();
  // フリーページ
  guideToggle();
});

//PC
function isPC(){
  return $(window).width() > 749;
}
// トップページか判定
function isTopPage(){
  var homeUrlPathName = '/';
  // 最後のスラッシュを消す（デモ環境対策）
  homeUrlPathName = homeUrlPathName.slice(0, homeUrlPathName.length-1);
  var regex = '^' + homeUrlPathName + '\/?$';
  return Util.isPageRegex(regex);
}

/* 外部リンクを新規タブで開く
=====================================================================*/
function linkOpenNewTab() {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}

/* ページトップ
=====================================================================*/
function pageTop(){
  var topBtn = $(".pagetop");
  topBtn.click(function () {
    $('html,body').animate({
      scrollTop: 0
    });
    return false;
  });
}

/* ページ内リンク
=====================================================================*/
function pageLink(){
  $('.page-link a[href^="#"], .js-page-link a[href^="#"]').click(function(){
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 100;
    $('body,html').animate({scrollTop:position}, 10, 'swing');
  });
}

/* グローバルナビ
=====================================================================*/
function gNav(){
  /* Gナビ */
  $('.js-gnav-btn,.js-sp-nav-btn').click(function(){
    $('.gnav').toggleClass('is-show');
    $(this).toggleClass('is-active');
    $('.gnav-sp-search').removeClass('is-show');
    $('.js-search-toggle').removeClass('is-active');
  });
  $(document).on('click', function(e) {
    if($('.gnav').hasClass('is-show')){
      if(!$(e.target).closest('.gnav-main,.js-gnav-btn,.js-sp-nav-btn').length) {
        //ここに外側をクリックしたときの処理
        $('.gnav').removeClass('is-show');
      } else {
        //ここに内側をクリックしたときの処理
      }
    }
  });
  if(!isPC()){
    $('.js-child-toggle').click(function(){
      $(this).next('.js-child-toggle-menu').slideToggle();
    });
  }

  /* 検索エリア */
  $('.js-search-toggle').click(function(){
    //$('.js-search-block').toggleClass('is-show');
    $('.gnav-sp-search').toggleClass('is-show');
    $(this).toggleClass('is-active');

    $('.gnav').removeClass('is-show');
    $('.js-gnav-btn,.js-sp-nav-btn').removeClass('is-active');

  });
  $('.search-modal__close-button').click(function(){
    $('.js-search-block').removeClass('is-show');
    $('.js-search-toggle').removeClass('is-active');
  });
  $(document).on('click', function(e) {
    if($('.gnav-sp-search').hasClass('is-show')){
      if(!$(e.target).closest('.gnav-main,.sp-nav-btn-search,.js-search-toggle').length) {
        //ここに外側をクリックしたときの処理
        $('.gnav-sp-search').removeClass('is-show');
      } else {
        //ここに内側をクリックしたときの処理
      }
    }
    /*
    if($('.js-search-block').hasClass('is-show')){
      $('.js-sp-nav-btn').removeClass('is-active');
      if(!$(e.target).closest('.js-search-toggle, .js-search-block .search-modal__content').length) {
        //ここに外側をクリックしたときの処理
        $('.js-search-block').removeClass('is-show');
      } else {
        //ここに内側をクリックしたときの処理
      }
    }
    */
  });
}

/* ドロップダウンメニュー
=====================================================================*/
function dropdownMenu(){
  $('.js-menu-dropdown').hover(
    function() {
      $(this).find('.js-menu-dropdown-menu').addClass('is-show');
    },
    function() {
      $(this).find('.js-menu-dropdown-menu').removeClass('is-show');
    }
  );
}

/* 商品詳細タブ
=====================================================================*/
function productDetailTabs(){
  /* Tabs
  -------------------------------------------------------- */
  $('.tab-wrap .tab-btn:first-child').addClass('is-active');
  $('.tab-wrap .tab-panel:first-child').addClass('is-show');
  $('.tab-btn').click(function(){
    // クリックした要素の先祖要素の中で、classの値がgroupの要素を取得
    var group = $(this).parents('.tab-wrap');
    group.find('.is-active').removeClass('is-active');
    $(this).addClass('is-active');
    group.find('.is-show').removeClass('is-show');
    // クリックしたタブからインデックス番号を取得
    const index = $(this).index();
    // クリックしたタブと同じインデックス番号をもつコンテンツを表示
    group.find(".tab-panel").eq(index).addClass('is-show');
  });

  $('.js-panel-toggle').click(function(){
    $(this).toggleClass('is-active');
    $(this).next('.js-panel').slideToggle();
  });
}

/* カラー・サイズ選択モーダル
=====================================================================*/
function variantSelectModal(){
  $('.js-open-variants').click(function(){
    $('.variant-select-area').toggleClass('is-show');
    $(this).toggleClass('is-active');
    $('body').toggleClass('is-variants-open');
  });
  $('.variant-select-close').click(function(){
    $('.variant-select-area').toggleClass('is-show');
    $('body').toggleClass('is-variants-open');
  });
}

/* スマホナビの検索ボタンクリック時、PFSフィルターを開く
=====================================================================*/
function openProductFilters() {
  var btn = '.boost-pfs-filter-tree-mobile-button';
  var openFlg = '';
  if($(window).width() < 750) {
    if($(btn).length) {
      // パラメータがあるときのみ表示
      var url = new URL(decodeURIComponent(window.location.href));
      // URLSearchParamsオブジェクトを取得
      var urlParams = url.searchParams;
      if(!urlParams.get('pfsFilters')) {
        // なければ終了
        return;
      } else {
        openFlg = urlParams.get('pfsFilters');
        if(openFlg == 'open') {
          setTimeout(function(){
            $('html').addClass('boost-pfs-body-no-scroll');
            $('body').addClass('boost-pfs-filter-tree-open-body');
            $('.boost-pfs-filter-tree-mobile-sticky').addClass('boost-pfs-filter-tree-mobile-open');
            $('.boost-pfs-filter-options-wrapper').css({'top':'40px'});
          },300);
        }
      }
    }
  }
}
/* PFSバグ対策 すべて適用するクリック時にリロードする
=====================================================================*/
function pfsReload() {
  $(document).on('click','.boost-pfs-filter-apply-all-button', function(){
    setTimeout(function(){
      location.reload();
    },100);
  });
}



/* Swatchの位置変更
=====================================================================*/
function swatchPosition() {
  $('.boost-pfs-filter-product-item').each(function(){
    var swatch = $(this).find('variant-swatch-king');
    $(this).find('.card-swatch-fav').prepend(swatch);
  });
}

/* 予約販売商品SKUが設定されている場合、当該SKUが在庫切れになるとカート投下ボタンを「予約商品」に変更する
=====================================================================*/
function displayPreorderBtn(productHandle,arr,productVariants){
  var addCartBtnWrapper = '.product-form';
  var addCartBtn = '.product-form__submit';
  var skuLink = '.js-preorder-link';
  var skuLinkBtn = '.js-preorder-link-btn';
  var nyukaNoticeBtn = '.illi-notify-restocks-accept-button';
  var jumpUrl = '#';

  // 予約商品のvariantIDを特定
  var preorderItemHandle = productHandle + '_1';
  var apiUrl = '/products/'+preorderItemHandle+'.js';
  $.when(
    $.ajax({
      url: apiUrl,
      type: 'GET',
      dataType: 'json',
      async: false,
      timeout: 30000,
    }).then(
      function (data) {
        if (data) {
          //成功の処理 予約商品のjsonを返す
          return data;
        } else {
          console.error('No data.');
        }
      },
      function () {
        // Ajax通信自体に失敗した場合の処理
        console.error("No connection.");
      }
    )
  ).done(function (data) {
    // 完了後の処理
    changePreorderBtn();
    $('#variantsID').on('change', function(){
      changePreorderBtn();
    });

    function changePreorderBtn(){
      var variantsID = $('#variantsID').val();
      console.log('changePreorderBtn 実行');
      for (const elem of arr) {
        // 商品情報の配列に予約商品コードと同じSKUがあるかチェック
        const result = productVariants.find((v) => v.sku === elem);
        if (!result) {
          // 同じSKUがなければ何もせず次のループへ
          continue;
        } else {
          // SKUが売り切れ時にボタンを変更する処理
          if(result.available) {
            // 在庫あれば何もせず次のループへ
            continue;
          } else {
            // 在庫なし・商品SKUが予約商品SKUと一致した場合に実行
            if(variantsID == result.id) {
             //既存のボタンを隠す
              $(addCartBtnWrapper).hide();
              $(nyukaNoticeBtn).hide();
              //予約商品と一致するバリアントを検索してIDを取得
              const preorderResult = data.variants.find((v) => v.sku === elem);
              //予約商品ボタンにURLをセットして表示
              if(preorderResult.id) {
                jumpUrl = '/products/'+preorderItemHandle+'?variant='+preorderResult.id;
                $(skuLinkBtn).attr('href', jumpUrl);
                $(skuLink).show();
                // 予約商品ボタンを表示してループ終了
                break;
              }
            } else {
              // 予約商品SKUではない場合は既存のSOLDOUTボタンを表示
              $(addCartBtnWrapper).show();
              $(nyukaNoticeBtn).show();
              $(skuLinkBtn).attr('href', '#');
              $(skuLink).hide();
            }
          }
        }
      }

    }
  });

}




/*
 * アイコンの表示制御
 */
function controlProductIconDisplay(serverResponse){

  var newIconClass = '.badge--new';//新商品タグのclass名
  var comingIconClass = '.badge--comingsoon';//ComingSoonタグのclass名
  var gridItemClass = '.product-card';//グリッドの各商品を括っているclass名
  var productItem;

  //新商品タグの数分処理
  for( var i=0; i<$( newIconClass ).length; i++ ){
    //各商品のDOMを取得
    $productItem = $( newIconClass ).eq(i).parents( gridItemClass );
    if( $productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, $productItem );
    }
  }

  //comingsoonタグの数分処理
  for( var i=0; i<$( comingIconClass ).length; i++ ){
    //各商品のDOMを取得
    $productItem = $( comingIconClass ).eq(i).parents( gridItemClass );
    if( $productItem.length ){
      //comingsoonアイコンの表示制御
      mainControlComingProductIconDisplay( serverResponse, $productItem );
    }
  }

  //Product Page
  if( $( '.body-product' ).length ){
    $productItem = $( '.product__info-container' );
    if( $productItem.length ){
      //新商品アイコンの表示制御
      mainControlNewProductIconDisplay( serverResponse, $productItem );
      //comingsoonアイコンの表示制御
      mainControlComingProductIconDisplay( serverResponse, $productItem );
    }
  }

}

/*
 * 新商品アイコンの表示制御（メイン処理）
 */
function mainControlNewProductIconDisplay( serverResponse, $productItem ){

  var displayPeriod = 30;//新商品タグの表示期間
  var newIconClass = '.badge--new';//新商品タグのclass名

  //今日の日付を取得
  var today = new Date(serverResponse);

  //発売日を取得
  var releaseDateStr = $productItem.find( '.js-release_date' ).text().trim();

  if(releaseDateStr) {
    var releaseDate = new Date(releaseDateStr);
    var releaseDateEnd = new Date(releaseDateStr);

    //表示期間の最終日を計算
    releaseDateEnd.setDate(releaseDateEnd.getDate() + displayPeriod);

    //発売日が先
    if( today.getTime() < releaseDate.getTime() ){
      // 新商品タグを非表示
      $productItem.find( newIconClass ).hide();
      return false;
    }

    //表示期間内
    if( today.getTime() <= releaseDateEnd.getTime() ){
      // 新商品タグを表示
      $productItem.find( newIconClass ).show();
    } else {
      $productItem.find( newIconClass ).hide();
    }

  } else {
    $productItem.find( newIconClass ).hide();
  }

}

/*
 * ComingSoon表示制御（メイン処理）
 */
function mainControlComingProductIconDisplay( serverResponse, $productItem ){
  var comingIconClass = '.badge--comingsoon';//ComingSoonタグのclass名
  var cartBtnClass = '.product-form__submit';

  //今日の日付を取得
  var today = new Date(serverResponse);

  //発売日を取得
  var releaseDateStr = $productItem.find( '.js-release_date' ).text().trim();

  if(releaseDateStr) {
    var releaseDate = new Date(releaseDateStr);

    // 発売開始前
    $productItem.find( comingIconClass ).hide();
    if( today.getTime() <= releaseDate.getTime() ){
      // Coming soonを表示
      $productItem.find( comingIconClass ).show();
      // 購入ボタンを非表示
      $( '.product-form__submit' ).remove();
      // 数量を非表示
      $('.product-form__quantity').remove();
      // 入荷お知らせを非表示
      $('.illi-notify-restocks-accept-button').remove();
      // 購入できないボタンを表示
      $( '.js-release_date--disable' ).show();
    } else {
      $productItem.find( comingIconClass ).hide();
      //購入ボタンを表示
      $( '.product-form__submit' ).show();
    }
  } else {
    $productItem.find( comingIconClass ).hide();
    $( '.product-form__submit' ).show();
  }
}

/*
 * カートページ 発売開始前商品の購入制限
 */
function controlCartPurchaseReleaseDate( serverResponse ){

  var dateClass = '.js-release_date';
  var gridItemClass = '.cart__product-information';//グリッドの各商品を括っているclass名
  var productItem;

  //今日の日付を取得
  var today = new Date(serverResponse);

  //日付の設定がない場合は処理終了
  if( $( dateClass ).length < 1 ){
    return;
  }

  for( var i=0; i<$( dateClass ).length; i++ ){
    //各商品のDOMを取得
    $productItem = $( dateClass ).eq(i).parents( gridItemClass );

    //購入制御
    if( $productItem.length ){
      //発売日を取得
      var releaseDateStr = $productItem.find( dateClass ).text().trim();
      var releaseDate = new Date(releaseDateStr);


      // 発売日前なら
      if( today <= releaseDate ){
        //購入ボタンを非表示にし、購入できないボタン・メッセージを表示
        $( '.js-cart__buttons-container' ).addClass( 'cart__submit__disable' );
        $( '.cart__submit__disable--note:not(.js-release_date--message)' ).hide();
        $( '.js-release_date--message' ).show();
        // ひとつでもあれば処理終了
        return;
      // 発売後
      }else{
        //購入ボタンを表示
        $( '.cart__submit' ).show();
      }
    }
  }
}

/*
 * 現在時刻をサーバーから取得して各種処理
 */
function processingMultipleGetServerDate(){
  $.ajax({
    type : 'HEAD',
    url :  window.location.href,
    cache : false
  }).done(function(data, textStatus, xhr) {
    try {
      var serverResponse = new Date(xhr.getResponseHeader("Date"));
    } catch(e) {
      var serverResponse = new Date();
    }

    //Top page
    if( isTopPage() ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
    }

    //Collection Page / Search Page
    if( $( '.body-search' ).length || $( '.body-collection' ).length ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);
    }

    //Product page / Cart page
    if( $( '.body-product' ).length > 0 || $( '.body-cart' ).length > 0 ){
      //新商品アイコンの表示制御
      controlProductIconDisplay(serverResponse);

      //発売開始前の購入制御
       controlCartPurchaseReleaseDate(serverResponse);
    }


  }).fail(function() {
    var serverResponse = new Date();
    // 失敗時の制御
  });

}

/*------------------------------------------------------------
  Cookie使用への同意
--------------------------------------------------------------*/
function cookieConsent() {
  (function() {
    const expire = 365; // 有効期限（日）
    let cc = document.querySelector('.cookie-consent');
    let ca = document.querySelector('.cookie-agree');
    const flag = localStorage.getItem('popupFlag');
    if (flag != null) {
      const data = JSON.parse(flag);
      if (data['value'] == 'true') {
        setTimeout(popup, 2000);
      } else {
        const current = new Date();
        if (current.getTime() > data['expire']) {
          setWithExpiry('popupFlag', 'true', expire);
          setTimeout(popup, 2000);
        }
      }
    } else {
      setWithExpiry('popupFlag', 'true', expire);
      setTimeout(popup, 2000);
    }
    ca.addEventListener('click', () => {
      cc.classList.add('cc-hide1');
      setWithExpiry('popupFlag', 'false', expire);
    });

    function setWithExpiry(key, value, expire) {
      const current = new Date();
      expire = current.getTime() + expire * 24 * 3600 * 1000;
      const item = {
        value: value,
        expire: expire
      };
      localStorage.setItem(key, JSON.stringify(item));
    }

    function popup() {
      cc.classList.add('is-show');
    }
  }());
}

/****************************************************************************
* フリーページ関連
****************************************************************************/
// ご利用ガイド
function guideToggle() {
  $(".guide_menu dt").on("click", function() {
    $(this).next().slideToggle();
    // activeが存在する場合
    if ($(this).children(".accordion_icon_guide").hasClass('active')) {
      // activeを削除
      $(this).children(".accordion_icon_guide").removeClass('active');
    }
    else {
      // activeを追加
      $(this).children(".accordion_icon_guide").addClass('active');
    }
  });
}

/****************************************************************************
* 商品画像の矢印ボタンの処理
****************************************************************************/
function processingImageArrowButton(){

  //商品画像が2枚以上の場合
  if( $('.product__media-item').length >= 2 ){
    //前へ、次へボタンを表示
    $('.slider-mobile-gutter').prepend('<div class="customize-prev-btn"></div>');
    $('.slider-mobile-gutter').append('<div class="customize-next-btn"></div>');

  //それ以外の場合、処理終了
  }else{
    return false;
  }

  //動作
  var activeIndex;

  //「＜」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-prev-btn", function () {
    //カレント画像が何番目かを取得
    activeIndex = $('.thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-list__item');
    //一枚目の場合
    if( activeIndex == 0 ){
      //処理終了
      return false;
    }
    //ひとつ前の画像を表示
    $('.thumbnail-list__item').eq(activeIndex - 1).find('button').click();
  });

  //「＞」の矢印ボタンをクリックしたとき
  $(document).on("click", ".customize-next-btn", function () {
    //カレント画像が何番目かを取得
    activeIndex = $('.thumbnail[aria-current]').parent('.thumbnail-list__item').index('.thumbnail-list__item');
    //最後の画像の場合、処理終了
  if( activeIndex == $('.thumbnail-list__item').length-1 ){
      return false;
    }
    //ひとつ後の画像を表示
    $('.thumbnail-list__item').eq(activeIndex + 1).find('button').click();
  });
}
/* 商品画像選択モーダル
=====================================================================*/
function itemGalleryModal(){
  $('.sp-media-list-btn').click(function(){
    $('.sp-media-thumb-gallery').addClass('is-show');
    $(this).addClass('is-active');
    $('body').addClass('is-thumb-open');
  });
  $('.sp-media-thumb-gallery-close').click(function(){
    $('.sp-media-thumb-gallery').removeClass('is-show');
    $('body').removeClass('is-thumb-open');
  });
}
